import { render, staticRenderFns } from "./EditBook.vue?vue&type=template&id=2eb1696d&"
import script from "./EditBook.vue?vue&type=script&lang=js&"
export * from "./EditBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports